import { useEffect } from "react";

/**
 * Lightweight SEO hook that updates document title, meta description,
 * canonical URL, and Open Graph tags on route change. No dependencies.
 */
export default function useSEO({ title, description, path, ogImage }) {
  useEffect(() => {
    const fullTitle = title || "The Tandem T Foundation";
    const desc =
      description ||
      "The Tandem T Foundation — a federally recognized 501(c)(3) nonprofit supporting mothers and children rebuilding after domestic violence.";
    const canonical = `https://tandemtfoundation.org${path || ""}`;
    const image = ogImage || "https://tandemtfoundation.org/brand/tandem-t-logo.png";

    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(attr === "content" ? "meta" : "link");
        if (selector.includes("property=")) {
          el.setAttribute("property", selector.match(/property="([^"]+)"/)[1]);
        } else if (selector.includes("name=")) {
          el.setAttribute("name", selector.match(/name="([^"]+)"/)[1]);
        } else if (selector.includes("rel=")) {
          el.setAttribute("rel", selector.match(/rel="([^"]+)"/)[1]);
        }
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", desc);
    setMeta('link[rel="canonical"]', "href", canonical);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[property="og:image"]', "content", image);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", desc);
    setMeta('meta[name="twitter:image"]', "content", image);
  }, [title, description, path, ogImage]);
}
